.scroll-top {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  height: 1.5rem;
  width: 1.5rem;
  font-size: 1.5em;
  @media screen and (min-width: 768px) {
    right: 2rem;
    bottom: 2rem;
    height: 2rem;
    width: 2rem;
  }
  cursor: pointer;
  display: block;
  z-index: 9997;
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
  transition: all 200ms linear;
  background-color: #fcdc93;
  -webkit-mix-blend-mode: difference;
  -moz-mix-blend-mode: difference;
  -o-mix-blend-mode: difference;
  -ms-mix-blend-mode: difference;
  mix-blend-mode: difference;
  mask-image: url(../../images/icons/dropdown-up.svg);
  mask-repeat: no-repeat;
  mask-size: contain;

  &.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

}
